'use strict';

module.exports = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};



//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/defaults/transitional.js
// module id = 62
// module chunks = 1